import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Loader2, Upload } from "lucide-react";

export const CustomerImportDialog = ({
  open,
  onOpenChange,
  importFile,
  setImportFile,
  updateExisting,
  setUpdateExisting,
  importing,
  onImport,
  onCancel,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>CSV-Import</DialogTitle>
        <DialogDescription>
          Importieren Sie Kunden aus einer CSV-Datei. Die Datei sollte folgende Spalten enthalten: Firma, Adresse, PLZ, Stadt, Telefon, E-Mail, Notizen
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label htmlFor="csv-file">CSV-Datei auswählen</Label>
          <Input
            id="csv-file"
            type="file"
            accept=".csv"
            onChange={(e) => setImportFile(e.target.files[0])}
            data-testid="import-file-input"
          />
          {importFile && (
            <p className="text-sm text-muted-foreground">
              Ausgewählt: {importFile.name}
            </p>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="update-existing"
            checked={updateExisting}
            onCheckedChange={setUpdateExisting}
            data-testid="update-existing-checkbox"
          />
          <Label htmlFor="update-existing" className="text-sm font-normal cursor-pointer">
            Bestehende Kunden aktualisieren (basierend auf Firmenname)
          </Label>
        </div>
        <div className="bg-muted/50 rounded-lg p-3 text-sm">
          <p className="font-medium mb-1">Hinweis:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1">
            <li>CSV mit Semikolon (;) als Trennzeichen</li>
            <li>UTF-8 Kodierung empfohlen</li>
            <li>Erste Zeile muss Spaltenüberschriften enthalten</li>
          </ul>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel}>
          Abbrechen
        </Button>
        <Button onClick={onImport} disabled={importing || !importFile} data-testid="import-submit-btn">
          {importing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
          Importieren
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
